import React from "react";

import IconButton, { IconButtonProps } from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';

export function DeleteButton(props: IconButtonProps) {
  return <IconButton 
    aria-label="edit" 
    size="medium"
    {...props}
  >
    <DeleteIcon fontSize="inherit" />
  </IconButton>
}
